<template>
    <layout>
        <div class="row text-center pt-3 pt-xl-5">
            <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6">
                <p class="h2"><em>Box 1</em></p>
                <v-date-picker mode='range' is-inline
                               :columns="$screens({ default: 1, lg: 2 })"
                               :rows="$screens({ default: 1, lg: 1 })"
                               :is-expanded="$screens({ default: true, lg: false })"
                               :attributes="attributesBox1"
                               :disabled-dates='bookingsBox1'
                               :min-date="new Date()"
                               :first-day-of-week="2"
                               :locale="locale"
                               v-model='selectedDates1'>
                </v-date-picker>
                <p class="h3 mt-5"><el-button type="primary" @click.prevent="$refs.book.show(1, selectedDates1)" :disabled="!selectedDates1">{{translate("BookNow")}}</el-button></p>
            </div>
            <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6 pt-5 pt-md-0">
                <p class="h2"><em>Box 2</em></p>
                <v-date-picker mode='range' is-inline
                               :columns="$screens({ default: 1, lg: 2 })"
                               :rows="$screens({ default: 1, lg: 1 })"
                               :is-expanded="$screens({ default: true, lg: false })"
                               :attributes="attributesBox2"
                               :disabled-dates='bookingsBox2'
                               :min-date="new Date()"
                               :first-day-of-week="2"
                               :locale="locale"
                               v-model='selectedDates2'>
                </v-date-picker>
                <p class="h3 mt-5"><el-button type="primary" @click.prevent="$refs.book.show(2, selectedDates2)" :disabled="!selectedDates2">{{translate("BookNow")}}</el-button></p>
            </div>
            <book ref="book" :products="products" @close="bookClose"></book>

            <div >
                <span style="background-color:#FEFCBF;color: #744210;">&nbsp;&nbsp;&nbsp;&nbsp;</span> : {{translate("CalendarLegendYellow")}}
                <span style="background-color:#FED7D7;color: #744210;">&nbsp;&nbsp;&nbsp;&nbsp;</span> : {{translate("CalendarLegendRed")}}
            </div>
        </div>
    </layout>
</template>

<script>
    import Vue from 'vue'
    import Layout from './layout.vue'
    import Book from './book.vue'

    import ElementUI from 'element-ui'; // see http://element.eleme.io/#/en-US/component
    import locale from 'element-ui/lib/locale/lang/fr'

    import VCalendar from 'v-calendar';
    //import 'v-calendar/lib/v-calendar.min.css';

    Vue.use(ElementUI, { locale })


    Vue.use(VCalendar, {
        firstDayOfWeek: 2,  // Monday
    });

    export default {
        data() {
            return {
                loading: true,
                selectedDates1: null,
                selectedDates2: null,
                products: [],
                bookings: [],
                locale: abp.localization.currentLanguage.name
            }
        },
        methods: {
            bookClose() {
                this.fetchData();
                this.selectedDates1 = null;
                this.selectedDates2 = null;
                //this.$message({
                //    message: 'Votre réservation a été enregistré avec succès.',
                //    type: 'success',
                //    duration:10000
                //});
                this.$alert(this.translate('BookingConfirmation'), this.translate('Booking'),  {

                    confirmButtonText: 'Ok',
                });
            },
            fetchData() {
                var self = this;
                abp.services.app.public.getBookings().done(function (data) {
                    self.bookings = data;
                }).always(function () {
                });
            },
            translate(key) {
                return abp.localization.values.App[key];
            }
        },
        computed: {
            isMobile: function () {
                return window.matchMedia("only screen and (max-width: 760px)").matches;
            },
            bookingsBox1() {
                return this.bookings.filter((b) => {
                    return b.box == 1;
                }).map((b => {
                    return {
                        start: b.buildUp,
                        end: b.pickUp,
                        confirmed: b.confirmed
                    };
                }));

            },
            bookingsBox2() {
                return this.bookings.filter((b) => {
                    return b.box == 2;
                }).map((b => {
                    return {
                        start: b.buildUp,
                        end: b.pickUp,
                        confirmed: b.confirmed
                    };
                }));

            },
            attributesBox1() {
                return [
                    {
                        key: 'options',
                        highlight: {
                            color: 'yellow',
                            fillMode: 'light'
                        },
                        dates: this.bookingsBox1.filter((b) => {
                            return !b.confirmed;
                        })
                    },
                    {
                        key: 'confirmed',
                        highlight: {
                            color: 'red',
                            fillMode: 'light'
                        },
                        dates: this.bookingsBox1.filter((b) => {
                            return b.confirmed;
                        })
                    }
                ];
            },
            attributesBox2() {
                return [
                    {
                        key: 'options',
                        highlight: {
                            color: 'yellow',
                            fillMode: 'light'
                        },
                        dates: this.bookingsBox2.filter((b) => {
                            return !b.confirmed;
                        })
                    },
                    {
                        key: 'confirmed',
                        highlight: {
                            color: 'red',
                            fillMode: 'light'
                        },
                        dates: this.bookingsBox2.filter((b) => {
                            return b.confirmed;
                        })
                    }
                ];
            }
        },
       
        created() {
            var self = this;
            abp.services.app.public.getProducts().done(function (data) {
                self.products = data;
            }).always(function () {
            });
            this.fetchData();
        },
        components: {
            layout: Layout,
            book: Book,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ClientApp/calendar/app.vue